import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const sections = [
  {
    heading: 'Getting Started',
    items: [
    ],
  },
  {
    heading: 'Getting Started',
    items: [
      { name: 'Agent Registration API', href: '/' },
      { name: 'WebRTC Client', href: '/docs/webrtc-client' },
      { name: 'Agent Registration Process', href: '/docs/agent-registration' },
      { name: 'Autodialer', href: '/docs/autodialer' }
    ],
  }
];

const Sidebar = ({ empty }) => {
  const location = useLocation();
  if (empty) {
    return (
      <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 bg-[#131926] border-r border-gray-900" />
    );
  }

  return (
    <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 bg-[#131926] border-r border-gray-900">
      <div className="flex-1 flex flex-col min-h-0 overflow-y-auto">
        <nav className="flex-1 px-6 pt-10 pb-8 space-y-8">
          {sections.map((section, idx) => (
            <div key={section.heading} className={idx !== 0 ? 'mt-6' : ''}>
              <div className="text-xs font-semibold text-gray-400 mb-3 tracking-wide uppercase">
                {section.heading}
              </div>
              <div className="flex flex-col space-y-1">
                {section.items.map((item) => {
                  const isActive = location.pathname === item.href;
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`transition-colors duration-150 px-0 py-1 text-base ${
                        isActive
                          ? 'text-white font-bold'
                          : 'text-gray-300 font-normal hover:text-white'
                      }`}
                      style={{letterSpacing: 0}}
                    >
                      {item.name}
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar; 